module.exports = __webpack_public_path__ + "static/img/13.b9c19f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/13.png
// module id = YOPq
// module chunks = 0